var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tickets"},_vm._l((_vm.tickets),function(ticket){return _c('app-panel-item',{key:ticket.id,attrs:{"text":ticket.badge.name,"subtext":_vm.ticketSubtext(ticket),"iconAfter":_vm.ticketIcon(ticket),"data-theme":_vm.ticketTheme(ticket)},on:{"click":function($event){return _vm.$emit('click', ticket)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }